import axios from 'axios';

var AUTH_API = process.env.REACT_APP_AUTH_URL;
var APP_USER = process.env.REACT_APP_USER;

class AuthService {

    apiAuth(){
        return axios({
            method: 'post',
            url: AUTH_API,
            data: {
              username: APP_USER,
              password: '134B;;+->-))<\"Y]3FX22GJL \n'
            }
          })
    }

}

export default new AuthService();